import * as React from "react";
import {
  Typography,
  Box,
  IconButton,
  Snackbar,
  Button as MaterialButton,
  Tooltip
} from "@mui/material";
import { connect } from "react-redux";
import {
  NavLink,
  Navigate,
  useNavigate,
} from "react-router-dom";
import {
  centered_flex_box, main_button,
} from "../app/components/Styles";
import { isMobile } from "react-device-detect";
import { Button, Image, Space, Table, Tag } from "antd";
import Logo from "../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import ImageComponent from "../app/components/ImageComponent";
import { getKeys, addKey } from "../app/store/actions/dataActions";
import { useEffect } from "react";
import { AddCircleOutline, CopyAll } from "@mui/icons-material";
import moment from "moment";
import copy from "clipboard-copy";
import { useState } from "react";
import NewCard from "../app/components/NewCard";
import { useTranslation } from 'react-i18next';

export const Keys = ({
  getKeys,
  addKey,
  user,
  apiKey,
  isLoading
}) => {
  const navigate = useNavigate();
  const [snackBar, setSnackBar] = useState(false);
  const { t } = useTranslation();

  const handleCopy = (link) => {
    copy(link);
    setSnackBar(true);
  };

  useEffect(() => {
    getKeys({})
  }, [])

  const columns = [
    {
      title: t('keys.id') || 'ID',
      dataIndex: '_id',
    },
    {
      title: t('common.name'),
      dataIndex: 'name',
    },
    {
      title: t('keys.apiKey'),
      dataIndex: 'value',
      render: (_, { value }) => <Space>{value}<Tooltip title={t('keys.copyKey') || 'Copy Key'}><IconButton sx={{ color: "var(--secColor4)" }} onClick={() => handleCopy(value)}><CopyAll /></IconButton></Tooltip></Space>
    },
    {
      title: t('keys.active') || 'Active',
      dataIndex: 'active',
      render: (_, { active }) => active ? t('keys.activeStatus') || 'ACTIVE' : t('keys.inactiveStatus') || 'INACTIVE'
    }
  ];

  const data = [{
    _id: apiKey?._id,
    name: apiKey?.name,
    value: apiKey?.value,
    active: apiKey?.active,
  }]

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor4)" }}>{t('navigation.shopifyIntegration')}</Typography>
          <IconButton onClick={() => addKey({})} sx={{ color: "var(--secColor4)", marginInlineStart: 2, marginInlineEnd: 2 }}><AddCircleOutline /></IconButton>
        </Box>
        <Table
          columns={columns}
          dataSource={data}
          showSorterTooltip={{
            target: 'sorter-icon',
          }}
        />
        <NewCard content={
          <Box>
            <Typography variant="h5" fontWeight={"bold"}>{t('keys.integrationInstructions') || 'Integration Instructions'}</Typography>
            <Typography gutterBottom={15}>1. <strong>{t('keys.install') || 'Install'}</strong> {t('keys.installDescription') || 'the CHAINZ Shopify App from the'} <NavLink className={"a2"} to={"https://apps.shopify.com/chainz-warehousing"} target="_blank">{t('keys.shopifyAppStore') || 'Shopify App Store'}</NavLink></Typography>
            <Typography gutterBottom={15}>2. {t('keys.step2Description') || 'After installing the app, you will find the input for the'} <strong>{t('keys.apiKeyInHomePage') || 'API Key in the home page'}</strong>, {t('keys.step2Description2') || 'add the API key shown at the top of this page.'} {apiKey && <NavLink className={"a2"} onClick={() => handleCopy(apiKey.value)}>{t('keys.copyKey') || 'Copy Key'}</NavLink>}</Typography>
            <Typography gutterBottom={15}>3. {t('keys.step3Description') || 'From the'} <strong>{t('keys.syncProductsPage') || '"Sync Products" page'}</strong>, {t('keys.step3Description2') || 'select all products you would like to fulfill with CHAINZ and press'} <strong>{t('keys.sendToChainz') || '"Send to CHAINZ"'}</strong>.</Typography>
            <Typography gutterBottom={15}>4. <strong>{t('keys.congratulations') || 'Congratulations!'}</strong> {t('keys.step4Description') || 'All orders placed on your store are automatically sent to your CHAINZ account. CHAINZ will also handle your inventory automatically. No action is required from your side to sync orders.'}</Typography>

          </Box>
        } />
        <Snackbar
          open={snackBar}
          autoHideDuration={3000}
          onClose={() => setSnackBar(false)}
          message={t('keys.keyCopied') || 'Key Copied'}
        />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  apiKey: state?.records?.key
});

const mapDispatchToProps = { getKeys, addKey };

export default connect(mapStateToProps, mapDispatchToProps)(Keys);
